import "./topbar.scss";
import { Person, Mail } from "@material-ui/icons";
import { Grid } from "@material-ui/core";

export default function Topbar({ menuOpen, setMenuOpen }) {
  return (
    <div className={"topbar " + (menuOpen && "active")}>
      <div className="wrapper">
        <div className="left">

          {

          }
          <a href="#intro" className="logo">
            Ali
          </a>
          <div className="itemContainer">
            <Person className="icon" />
            <span>+91 89294 93961</span>
          </div>
          <div className="itemContainer">
            <Mail className="icon" />
            <span>hello.shahanshah@gmail.com</span>
          </div>

        </div>


        <div className="right flex" style={{
          gap: "20px"
        }}>

          {/*  */}

          <div style={{

            display: "flex",
            justifyContent: "center",

            gap: "12px",



          }}>

            <div className="itemContainer">
              <a href="documents/Resume_MD_ALI_SHAHANSHAH.pdf" target="_blank" style={{
                textDecoration: "none",
                fontSize: "18px",
                fontWeight: "500"
                // color: "black"
              }}>

                <span style={{

                  fontSize: "18px",
                  fontWeight: "500"


                }} >View resume</span>

              </a>
            </div>

            <div>
              <a href="documents/Resume_MD_ALI_SHAHANSHAH.pdf" download="Resume_MD_ALI_SHAHANSHAH.pdf" style={{
                textDecoration: "none",
                // color: "black"
              }}>
                {/* <h3>Download resume</h3>*/}
              </a>
            </div>
          </div>


          {/*  */}
          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span className="line1"></span>
            <span className="line2"></span>
            <span className="line3"></span>
          </div>

        </div>


      </div>
    </div >
  );
}
